import { useEffect, useState } from "react"

//PrimeReact
import { AutoComplete } from "primereact/autocomplete"

//Styles
import myStyles from "../../../../styles/kiosk/KioskAdminFormWizard.module.css"
import { useField } from "formik"

//Formik
import * as Yup from "yup"

export default function WizardPageActionsEmailRecipient({
  staffList,
  fieldName,
  disabled,
}) {
  const [field, , helpers] = useField(fieldName)
  const emailSchema = Yup.string().email()

  const [recipients, setRecipients] = useState([])
  const [filteredList, setFilteredList] = useState([])

  useEffect(() => {
    if (field.value) {
      let eMails = field.value.split(";")

      let currentRecipients = eMails.map((value) => {
        return {
          staff_full_name: undefined,
          staff_role_name: undefined,
          staff_email_address: value,
        }
      })

      setRecipients(currentRecipients)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const autoCompleteSearch = (event) => {
    let filteredStaff

    if (!event.query.trim().length) {
      filteredStaff = [...staffList]
    } else {
      filteredStaff = staffList.filter((staff) => {
        return (
          (staff.staff_full_name
            .toLowerCase()
            .includes(event.query.toLowerCase()) ||
            staff.staff_email_address
              .toLowerCase()
              .includes(event.query.toLowerCase())) &&
          !recipients.some(
            (recipient) =>
              recipient.staff_email_address === staff.staff_email_address
          )
        )
      })
    }

    if (
      emailSchema.isValidSync(event.query) &&
      !recipients.some(
        (recipient) => recipient.staff_email_address === event.query
      )
    ) {
      filteredStaff = [
        {
          staff_full_name: undefined,
          staff_role_name: undefined,
          staff_email_address: event.query,
        },
        ...filteredStaff,
      ]
    }

    setFilteredList(filteredStaff)
  }

  const recipientTemplate = (item) => {
    if (item.staff_full_name !== undefined) {
      let logo = item.staff_full_name.trim().toUpperCase()[0]

      return (
        <div className={myStyles.recipientLayout}>
          <div className={myStyles.recipientLogo}>
            <div className={myStyles.logoField}>{logo}</div>
          </div>
          <div className={myStyles.recipientName}>
            {item.staff_full_name}{" "}
            <span className={myStyles.recipientRole}>
              {item.staff_role_name}
            </span>
          </div>
          <div className={myStyles.recipientEmail}>
            {item.staff_email_address}
          </div>
        </div>
      )
    } else {
      return (
        <div className={myStyles.recipientCustomLayout}>
          <div className={myStyles.recipientLogo}>
            <div className={myStyles.logoField}></div>
          </div>
          <div className={myStyles.recipientEmail}>
            {item.staff_email_address}
          </div>
        </div>
      )
    }
  }

  return (
    <div style={{ width: "100%" }}>
      <div>Recipients</div>
      <AutoComplete
        field="staff_email_address"
        multiple
        className={`${myStyles.autoComplete} ${"custom-chips"}`}
        value={recipients}
        suggestions={filteredList}
        completeMethod={autoCompleteSearch}
        onChange={(e) => {
          if (e.value !== null) {
            setRecipients(e.value || [])

            if (e.value?.length > 0) {
              let emails = e.value.map((value) => {
                return value.staff_email_address
              })
              helpers.setValue(emails.join(";"))
            } else {
              helpers.setValue("")
            }
          }
        }}
        itemTemplate={recipientTemplate}
        disabled={disabled}
        forceSelection
      />
    </div>
  )
}
